import React, { useState, useEffect, useRef } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { gsap } from 'gsap'
import { SwitchTransition, Transition } from 'react-transition-group'

import { Icon } from '..'
import { iconsKeys } from '../Icon/Icon.assets'

import useStyles from './styles'
import Logo from './img/logo.svg'


const Header = (props) => {
  const classes = useStyles(props)
  const {
    className,
    leftContent,
    rightContent,
    centerContent,
    isMenuOpen,
    menuContent,
    hasMenuToggle,
    hasBottomGradient,
    onLogoClick,
  } = props

  const $toogleMenu = useRef()

  const [isMenuOpenState, setIsMenuOpenState] = useState(isMenuOpen)
  const [isMenuVisible, setIsMenuVisible] = useState(isMenuOpenState)
  const [isContentVisible, setIsContentVisible] = useState(!isMenuOpenState)

  useEffect(() => {
    setIsMenuOpenState(isMenuOpen)
  }, [isMenuOpen])

  return (
    <header className={cx(className, classes.container, { 'header-bottom-gradient': hasBottomGradient })}>
      <div
        className={classes.wrapper}
      >
        <SwitchTransition>
          {isMenuOpenState ? (
            <Transition
              key="menu"
              onEntered={() => setIsMenuVisible(true)}
              onExited={() => setIsMenuVisible(false)}
              addEndListener={(node, done) => {
                if ($toogleMenu.current && isMenuVisible) {
                  gsap.to($toogleMenu.current, {
                    duration: 0.3,
                    rotation: 0,
                  })
                }
                gsap.fromTo(node, {
                  opacity: isMenuVisible ? 1 : 0,
                }, {
                  duration: 0.2,
                  opacity: isMenuVisible ? 0 : 1,
                  onComplete: done,
                })
              }}
            >
              <div className={classes.menu}>
                {menuContent}
              </div>
            </Transition>
          ) : (
            <Transition
              key="content"
              onEntered={() => setIsContentVisible(true)}
              onExited={() => setIsContentVisible(false)}
              addEndListener={(node, done) => {
                if ($toogleMenu.current && isContentVisible) {
                  gsap.to($toogleMenu.current, {
                    duration: 0.3,
                    rotation: -45,
                  })
                }
                gsap.fromTo(node, {
                  opacity: isContentVisible ? 1 : 0,
                }, {
                  duration: 0.2,
                  opacity: isContentVisible ? 0 : 1,
                  onComplete: done,
                })
              }}
            >
              <div className={classes.content}>
                <div className={classes.leftContent}>
                  {leftContent}
                </div>
                {centerContent || (
                  <Logo
                    alt="Logo"
                    className={classes.logo}
                    onClick={onLogoClick}
                  />
                )}
                <div className={classes.rightContent}>
                  {rightContent}
                </div>
              </div>
            </Transition>
          )}
        </SwitchTransition>
        {hasMenuToggle && (
        <div
          className={classes.menuToggle}
          ref={$toogleMenu}
          onClick={() => setIsMenuOpenState(((prevState) => !prevState))}
        >
          <Icon icon={iconsKeys.Plus} />
        </div>
        )}
      </div>
    </header>
  )
}

Header.propTypes = {
  className: PropTypes.string,
  leftContent: PropTypes.node,
  centerContent: PropTypes.node,
  rightContent: PropTypes.node,
  menuContent: PropTypes.node,
  isMenuOpen: PropTypes.bool,
  hasMenuToggle: PropTypes.bool,
  hasBottomGradient: PropTypes.bool,
  onLogoClick: PropTypes.func,
}

Header.defaultProps = {
  className: null,
  leftContent: null,
  centerContent: null,
  rightContent: null,
  menuContent: null,
  isMenuOpen: false,
  hasMenuToggle: false,
  hasBottomGradient: false,
  onLogoClick: undefined,
}

export default Header
